import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
const layerHasCopyright = (x) => 'copyright' in x && !!x.copyright;
export const MapAttribution = ({ mapView }) => {
    const [attribution, setAttribution] = useState('');
    useEffect(() => {
        var _a, _b;
        if (!mapView)
            return;
        const update = () => {
            var _a, _b;
            const sources = new Set();
            (_b = (_a = mapView.map) === null || _a === void 0 ? void 0 : _a.allLayers) === null || _b === void 0 ? void 0 : _b.forEach((layer) => {
                if (layerHasCopyright(layer)) {
                    layer.copyright.split(',').forEach((s) => {
                        const trimmed = s.trim();
                        if (trimmed)
                            sources.add(trimmed);
                    });
                }
            });
            setAttribution(Array.from(sources).join(', '));
        };
        const handle = (_b = (_a = mapView.map) === null || _a === void 0 ? void 0 : _a.allLayers) === null || _b === void 0 ? void 0 : _b.on('change', update);
        mapView.when(update);
        return () => { handle === null || handle === void 0 ? void 0 : handle.remove(); };
    }, [mapView]);
    return (_jsxs("div", { className: "map-attribution", children: ["Powered by", ' ', _jsx("a", { href: "https://www.esri.com", target: "_blank", rel: "noopener noreferrer", children: "Esri" }), attribution && ` | ${attribution}`] }));
};
